import Processes from './Processes';

export default Processes;
